module.exports = __webpack_public_path__ + "img/nanduf1.38fe93da.png";